module.exports = __webpack_public_path__ + "img/phone-border.006e40cc.png";